import React from "react";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
  getDefaultBlog,
  createBlogModal,
} from "../../redux/actions/blogAction";
import { logout } from "../../redux/actions/authAction";
import { Avatar } from "antd";
import { connect } from "react-redux";
import { profileCharacters } from "../../utils/helper";
import { useAuthStore } from "../../store/AuthStore";

const MobileProfileMenu = ({ toggleProfile, logout, createBlogModal }) => {
  const history = useHistory();
  const { hasBlog, isPhysician, blogData, userData } = useAuthStore();

  return (
    <>
      <div className="root">
        <div className="header">
          <IconButton
            style={{ marginLeft: "auto" }}
            size="small"
            onClick={() => {
              toggleProfile(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div
          className="header"
          onClick={() => {
            toggleProfile(false);
            history.push({
              pathname: !isPhysician
                ? "/user/dashboard"
                : `/dashboard/${blogData.urlSlug}/my_posts`,
              state: { key: !isPhysician ? "bookmarked" : "my_posts" },
            });
          }}
        >
          <Avatar
            size={60}
            src={userData.profileImage}
            icon={profileCharacters(userData.firstName, userData.lastName)}
          />
          <p
            className="name"
            onClick={() => {
              toggleProfile(false);
            }}
          >
            <span className="title">
              {isPhysician && "Dr."} {userData.firstName}{" "}
              {userData.lastName ?? ""}
            </span>

            <span className="title">{userData.title}</span>
          </p>
        </div>

        <div
          className="menu"
          style={{
            marginTop: "1rem",
            padding: "0 0.5rem",
          }}
        >
          {isPhysician && (
            <div className="submenu">
              {hasBlog ? (
                <>
                  <p
                    className="menu-title"
                    style={{
                      margin: "2.1rem 0",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      toggleProfile(false);
                      history.push(`/blogfolio/${blogData.urlSlug}/about`);
                    }}
                  >
                    My Blog
                  </p>
                  {blogData.postCount > 0 && (
                    <p
                      className="menu-title"
                      style={{
                        margin: "2.1rem 0",
                        fontWeight: "bold",
                      }}
                      onClick={() => {
                        toggleProfile(false);
                        history.push(`/dashboard/${blogData.urlSlug}/my_posts`);
                      }}
                    >
                      My Posts
                    </p>
                  )}
                  <p
                    className="menu-title"
                    style={{
                      margin: "2.1rem 0",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      toggleProfile(false);
                      history.push(
                        `/dashboard/${blogData.urlSlug}/blogs_i_follow`
                      );
                    }}
                  >
                    Blogs I Follow
                  </p>
                  <p
                    className="menu-title"
                    style={{
                      margin: "2.1rem 0",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      toggleProfile(false);
                      history.push(
                        `/dashboard/${blogData.urlSlug}/tags_i_follow`
                      );
                    }}
                  >
                    Tags I Follow
                  </p>
                </>
              ) : (
                <>
                  <button
                    className="create"
                    onClick={() => {
                      toggleProfile(false);
                      createBlogModal(true);
                    }}
                  >
                    + CREATE NEW BLOG
                  </button>

                  <hr className="line mb-4" />
                </>
              )}
            </div>
          )}

          {!isPhysician && (
            <div className="submenu">
              <p
                className="menu-title"
                style={{
                  margin: "2.1rem 0",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  toggleProfile(false);
                  history.push({
                    pathname: "/user/dashboard",
                    state: { key: "bookmarked" },
                  });
                }}
              >
                Dashboard
              </p>
            </div>
          )}
        </div>

        <div
          className="logout"
          onClick={() => {
            toggleProfile(false);
            logout();
            localStorage.clear();
            sessionStorage.clear();
            history.push("/");
            window.location.reload();
          }}
        >
          Log Out
        </div>
      </div>
      <style jsx="true">
        {`
          .create {
            height: 35px;
            width: 100%;
            margin-top: 1rem;
            border-radius: 8px;
            background-color: #ffa405;
            color: #fff;
            font-family: Lato;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 17px;
            margin-bottom: 30px;
          }
        `}
      </style>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.userData,
});

export default connect(mapStateToProps, {
  logout,
  getDefaultBlog,
  createBlogModal,
})(MobileProfileMenu);
